/**
 * Thin REST client for the server's /api endpoints.
 * Used through TanStack Query hooks; functions here are framework-free.
 */
import { env } from './env.js'

class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

/** POST /api/rooms → { roomId } */
export async function createRoom(): Promise<{ roomId: string }> {
  const res = await fetch(`${env.API_URL}/rooms`, { method: 'POST' })
  if (!res.ok) {
    throw new ApiError(res.status, `Failed to create room (HTTP ${res.status})`)
  }
  return (await res.json()) as { roomId: string }
}

/** GET /api/rooms/:id → { exists: boolean } (404 → exists:false, never throws on 404) */
export async function roomExists(id: string): Promise<boolean> {
  const res = await fetch(`${env.API_URL}/rooms/${encodeURIComponent(id)}`)
  if (res.status === 404) return false
  if (!res.ok) {
    throw new ApiError(res.status, `Room lookup failed (HTTP ${res.status})`)
  }
  const body = (await res.json()) as { exists: boolean }
  return body.exists
}

export { ApiError }
